import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTabIconPlaces = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 18,
	viewBox: "0 0 13 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 0C2.91142 0 0 2.92712 0 6.53838C1.88284e-07 13.0124 6.5 18 6.5 18C6.5 18 13 13.0124 13 6.53838C13 2.92712 10.0886 0 6.5 0Z",
		fill: "currentColor"
	})
});
export default SvgTabIconPlaces;
